'use client';

import { Skeleton } from '@/components/ui/skeleton';

export function LoginSkeleton() {
  return (
    <div className="w-full max-w-md space-y-8 bg-white mt-5">
      {/* Logo/Título */}
      <div className="text-center space-y-2">
        <Skeleton className="h-10 w-40 mx-auto" />
        <Skeleton className="h-4 w-32 mx-auto" />
      </div>

      {/* Formulario */}
      <div className="space-y-6 flex flex-col h-[400px]">
        {/* Campo Email */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-10 w-full" />
        </div>

        {/* Campo Contraseña */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-full" />
        </div>

        {/* Recordar contraseña */}
        {/* <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Skeleton className="h-4 w-4 rounded" />
            <Skeleton className="h-4 w-24" />
          </div>
          <Skeleton className="h-4 w-32" />
        </div> */}

        {/* Botón de Login */}
        {/* <Skeleton className="h-10 w-full rounded-md" /> */}

        {/* Separador */}
        {/* <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300" />
          </div>
          <div className="relative flex justify-center text-sm">
            <Skeleton className="h-4 w-16 bg-white px-2" />
          </div>
        </div> */}
      </div>
      <div className="grid ">
        <Skeleton className="h-12 w-full rounded-md" />
      </div>
    </div>
  );
}
